<div class="carousel-container">
  <figure class="current-figure">
    @if (images().length > 1) {
      <a class="nav-left" (click)="previousImage()">
        <svg-icon src="/assets/icons/general/chevron-left.svg" />
      </a>
    }

    <div class="image is-16by9">
      <img
        #currentImageRef
        class="current-image"
        (click)="showGallery()"
        [src]="currentImage.thumbUrl"
        (swipeleft)="nextImage()"
        (swiperight)="previousImage()"
      />

      @if (loadingImage) {
        <div [@imageLoaderFadeAnimation] class="image-loader">
          <div class="image-loader__spinner">
            <ag-spinner [size]="5" />
          </div>
        </div>
      }
    </div>

    @if (images().length > 1) {
      <a class="nav-right" (click)="nextImage()">
        <svg-icon src="/assets/icons/general/chevron-right.svg" />
      </a>
    }
  </figure>
</div>

<ag-modal-gallery [(isOpen)]="galleryIsOpen" [images]="images()" />
